
import Vue from "vue";
import Component from "vue-class-component";
import LandingpageIllustration from "@/components/LandingpageIllustration.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import { authService } from "@/AuthService";
import { ContactInfoViewModel, CountryLightModel, factory, IUpdateContactInfoRequest, PersonalInfoClient, ResultError, UpdateContactInfoRequest } from "@/api-client";
import ContactInfo from "@/features/personProfile/views/ContactInfo.vue";
import toasts from "@/components/Toasts";
import { NavigationGuardNext } from "vue-router";

@Component({
    components: {
        LandingpageIllustration,
        SectionPageHeading,
        ContactInfo
    },

    beforeRouteEnter(to, from, next: NavigationGuardNext<ConfirmPersonalData>)
    {

        if (!authService.confirmData || !authService.isLoggedIn)
        {
            const returnUrl = to.query?.returnUrl as string | undefined | null;
            next(returnUrl ?? "/")
        }
        next();
    }

})
export default class ConfirmPersonalData extends Vue 
{
    countries: CountryLightModel[] = authService.confirmData?.countries ?? []
    seafarerId: string = authService.confirmData!.seafarerId;
    contactInfo: ContactInfoViewModel = authService.confirmData!.contactInfo;
    validationErrors: ResultError = factory.create(ResultError);

    async saveContactInfo()
    {
        const requestModel: IUpdateContactInfoRequest = {
            phoneNumber: this.contactInfo.phoneNumber,
            email: this.contactInfo.email,
            address: this.contactInfo.address
        }
        await new PersonalInfoClient().updateContactInfo(new UpdateContactInfoRequest(requestModel), this.seafarerId)
            .then(async () =>
            {
                this.validationErrors.clear();
                this.contactInfo = await new PersonalInfoClient().getContactInfo(this.seafarerId);
                toasts.success(this.$ls.PersonProfile_PersonalInfo_Toast_Success_ContactDetailsSaved);
                window.location.reload();
            })
            .catch(error => this.setValidationErrors(error, this.$ls.PersonProfile_PersonalInfo_Toast_Failure_ContactDetailsNotSaved));
    }
}
